import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppSettings } from 'src/app/app.settings';

@Component({
  selector: 'app-wo-type-dialog',
  templateUrl: './wo-type-dialog.component.html',
  styleUrls: ['./wo-type-dialog.component.scss']
})
export class WoTypeDialogComponent implements OnInit {
  public form: UntypedFormGroup;
  woTypeData: any = {};

  constructor(
    public dialogRef: MatDialogRef<WoTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public appSettings: AppSettings,
    public fb: UntypedFormBuilder,
  ) {
    dialogRef.disableClose = true;
    this.form = this.fb.group({
      woTypeKey: null,
      woTypeName: [null, Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.appSettings.aplhaNumeric)])],
      status: ['ACTIVE', Validators.required]
    });
  }

  ngOnInit(): void {
    if (this.data) {
      this.woTypeData = this.data;
      this.form.controls.woTypeName.setValue(this.woTypeData.woTypeName);
      this.form.controls.woTypeKey.setValue(this.woTypeData.woTypeKey);
      this.form.controls.status.setValue(this.woTypeData.status);
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  onKeydownWoTypeName(event: any) {
    if (this.form.value.woTypeName?.endsWith(" ") && event.keyCode === 32) {
      return false;
    }
    if (!this.form.value.woTypeName && event.keyCode === 32) {
      return false;
    }
    return true;
  }
}